import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { RootState } from "../../store";
import { applyBusinessContextHeaders } from "../../common/util/businessHeaders";
import { TTCIResponse } from "./corePlusIncentivesApi.types";

type BaseRequestParams = {
  baseUrl: string;
  affAbo: string;
  bonusPeriod: string;
  countryCode?: string;
  targetAffAbo?: string;
};

export const corePlusIncentivesApi = createApi({
  reducerPath: "corePlusIncentivesApi",
  baseQuery: fetchBaseQuery({
    prepareHeaders: (headers, { getState }) => {
      const rootState = getState() as RootState;
      const { user, configuration } = rootState.boot;
      if (user && user.access_token) {
        headers.set("Authorization", `Bearer ${user.access_token}`);
        headers.set("x-mashery-domain", configuration.requestUrlBase);
        headers.set("Content-Type", "application/json");
      }

      applyBusinessContextHeaders(headers, rootState);

      return headers;
    },
  }),

  endpoints: (builder) => ({
    getTtciApi: builder.query<TTCIResponse, BaseRequestParams>({
      query: (params) => ({
        url: `${params.baseUrl}/ttci/${params.bonusPeriod}/${params.affAbo}`,
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetTtciApiQuery } = corePlusIncentivesApi;
